import React, { useEffect, useState } from 'react';

import {
  PageWrapper,
  LoadingContainer,
  useNotification
} from '@ubisend/pulse-components';
import { Drivers } from '@ubisend/pulse-hooks';
import { useAuth } from '@ubisend/pulse-auth';

import { getAllDrivers, getDriver, updateDriver } from '../api/index';

const NlpDrivers = () => {
  const [drivers, setDrivers] = useState();
  const [driver, setDriver] = useState();

  const { showSuccess } = useNotification();
  const { hasPermission } = useAuth();

  const fetchDrivers = async () => {
    const { data } = await getAllDrivers();
    setDrivers(data.data);
  };

  const fetchDriver = async () => {
    const { data } = await getDriver();
    setDriver(data.data.id);
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  useEffect(() => {
    fetchDriver();
  }, []);

  const handleDriver = async driver => {
    await updateDriver(driver.id);
    showSuccess(`Successfully made ${driver.name} your NLP Provider.`);
    setDriver(driver.id);
  };

  const loading = !drivers || !driver;

  const copy = {
    available: {
      title: 'Available NLP providers',
      info: 'Select an NLP provider to power your chatbot.'
    },
    other: {
      title: 'Other NLP providers',
      info: 'Contact us for a custom implementation of these NLP providers.'
    }
  };

  return (
    <PageWrapper header="NLP" subheader="Choose your NLP provider">
      {loading && <LoadingContainer />}
      {!loading && (
        <Drivers
          copy={copy}
          type="single"
          required
          value={driver}
          drivers={drivers.map(d =>
            d.id === 13 ? { ...d, link: '/nlp/settings' } : d
          )}
          handleClick={handleDriver}
          canEditDriver={d => d.id === 13}
          canEnableDriver={() => hasPermission('edit nlp providers')}
          canDisableDriver={() => hasPermission('edit nlp providers')}
        />
      )}
    </PageWrapper>
  );
};

export default NlpDrivers;
